import { FC } from 'react';

import Button, { ButtonKind } from 'bloko/blocks/button';
import Column from 'bloko/blocks/column';
import HSpacing from 'bloko/blocks/hSpacing';
import Modal, { ModalFooter } from 'bloko/blocks/modal';
import Text from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

interface ActSplitConfirmationProps {
    isVisible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const TrlKeys = {
    cancelButton: 'admin.actsReport.actsTable.splitConfirmation.cancel',
    confirmButton: 'admin.actsReport.actsTable.splitConfirmation.confirm',
    content: 'admin.actsReport.actsTable.splitConfirmation.content',
};

const ActSplitConfirmation: FC<ActSplitConfirmationProps> = ({ isVisible, onCancel, onConfirm }) => {
    const trl = useTrls();

    return (
        <Modal visible={isVisible} onClose={onCancel}>
            <Column xs="4" s="6" m="6" l="6" container>
                <Text>{trl(TrlKeys.content)}</Text>
            </Column>
            <ModalFooter>
                <Button onClick={onCancel}>{trl(TrlKeys.cancelButton)}</Button>
                <HSpacing base={4} />
                <Button kind={ButtonKind.Primary} onClick={() => onConfirm()} data-qa="act-sprit-confirm">
                    {trl(TrlKeys.confirmButton)}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ActSplitConfirmation;
